import { createBrowserHistory } from 'history';

// create custom history so that I can redirect in api file
export const history = createBrowserHistory();
